import type { CommitmentVersion } from '@festina/life-general-types/life'
import type { Optional } from '@festina-life/core'

export const isCommitmentVersion = <T extends CommitmentVersion>(
  x: Optional<CommitmentVersion>,
): x is T => x?._type === 'CommitmentVersion'
